"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Operator = _interopRequireDefault(require("../Operator"));
var _excluded = ["operators", "onCall", "onTransfer", "onListen", "onRequestHelp"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var OperatorStates = _Operator["default"].States;
var PhoneMonitoring = /*#__PURE__*/function (_React$PureComponent) {
  function PhoneMonitoring() {
    (0, _classCallCheck2["default"])(this, PhoneMonitoring);
    return _callSuper(this, PhoneMonitoring, arguments);
  }
  (0, _inherits2["default"])(PhoneMonitoring, _React$PureComponent);
  return (0, _createClass2["default"])(PhoneMonitoring, [{
    key: "isVisible",
    value: function isVisible(_ref) {
      var operator = _ref.operator;
      var visible = true;
      var name = operator.name,
        number = operator.number,
        state = operator.state,
        isCallCenter = operator.isCallCenter;
      var _this$props = this.props,
        searchQuery = _this$props.searchQuery,
        visibleOnly = _this$props.visibleOnly;
      var ONLINE = OperatorStates.ONLINE,
        READY = OperatorStates.READY,
        IN_SERVICE = OperatorStates.IN_SERVICE;
      if (searchQuery.length > 0) {
        var checkName = name.toLowerCase().includes(searchQuery.toLowerCase());
        var checkNumber = number.includes(searchQuery);
        visible = checkName || checkNumber;
      }
      if (visibleOnly[0] === 'online') {
        visible = visible && [ONLINE, READY, IN_SERVICE].includes(state);
      }
      if (visibleOnly[0] === 'operators') {
        visible = visible && isCallCenter;
      }
      return visible;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props2 = this.props,
        operators = _this$props2.operators,
        onCall = _this$props2.onCall,
        onTransfer = _this$props2.onTransfer,
        onListen = _this$props2.onListen,
        onRequestHelp = _this$props2.onRequestHelp,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledPhoneMonitoring, props, operators.map(function (operatorData) {
        return _this.isVisible(operatorData) && /*#__PURE__*/_react["default"].createElement(_Operator["default"], (0, _extends2["default"])({}, operatorData, {
          onCall: onCall,
          onTransfer: onTransfer,
          onListen: onListen,
          onRequestHelp: onRequestHelp
        }));
      }));
    }
  }]);
}(_react["default"].PureComponent);
PhoneMonitoring.propTypes = {
  className: _propTypes["default"].string,
  operators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    call: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      pbxId: _propTypes["default"].string,
      duration: _propTypes["default"].number
    }),
    contact: _propTypes["default"].shape({
      name: _propTypes["default"].string,
      number: _propTypes["default"].number,
      isHidden: _propTypes["default"].bool
    }),
    operator: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      number: _propTypes["default"].string.isRequired,
      state: _propTypes["default"].string,
      skillGroups: _propTypes["default"].arrayOf(_propTypes["default"].string),
      canCall: _propTypes["default"].bool.isRequired,
      canTransfer: _propTypes["default"].bool.isRequired,
      canListen: _propTypes["default"].bool.isRequired,
      canRequestHelp: _propTypes["default"].bool.isRequired,
      isCallCenter: _propTypes["default"].bool
    }).isRequired
  })).isRequired,
  searchQuery: _propTypes["default"].string,
  visibleOnly: _propTypes["default"].arrayOf(_propTypes["default"].string),
  callID: _propTypes["default"].number,
  onCall: _propTypes["default"].func,
  onTransfer: _propTypes["default"].func,
  onListen: _propTypes["default"].func,
  onToggle: _propTypes["default"].func,
  onRequestHelp: _propTypes["default"].func
};
PhoneMonitoring.defaultProps = {
  className: '',
  callID: null,
  searchQuery: '',
  visibleOnly: ['all'],
  onCall: Function.prototype,
  onTransfer: Function.prototype,
  onListen: Function.prototype,
  onToggle: Function.prototype,
  onRequestHelp: Function.prototype
};
var StyledPhoneMonitoring = _styledComponents["default"].ul.withConfig({
  displayName: "PhoneMonitoring__StyledPhoneMonitoring",
  componentId: "sc-gmr3r3-0"
})(["width:400px;"]);
var _default = exports["default"] = PhoneMonitoring;